import { render, staticRenderFns } from "./PemenuhanKewajiban.vue?vue&type=template&id=85ba9502&"
import script from "./PemenuhanKewajiban.vue?vue&type=script&lang=js&"
export * from "./PemenuhanKewajiban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports